import { BrowserCacheLocation, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "../../../environments/environment";

function getRuntimeBaseUrl(): string {
  const baseHref = document.querySelector("base")?.getAttribute("href") ?? "/";
  return new URL(baseHref, window.location.origin).toString();
}

export function MSALInstanceFactory(): PublicClientApplication {
  const runtimeBaseUrl = getRuntimeBaseUrl();

  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: runtimeBaseUrl,
      postLogoutRedirectUri: runtimeBaseUrl,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
    },
  });
}
